module.exports = __webpack_public_path__ + "img/signal_wifi_2_bar-red.da7d8667.svg";